import React from 'react';
import {
	Col,
	Row,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	FormGroup,
	Label,
	Input,
	ModalFooter,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const CancelamentoComponent = ({
	isOpen,
	toggle,
	title,
	justificativaCancelar,
	cancelarEtapa,
	confirmTextLabel,
	setJustificativa,
}) => {
	const intl = useIntl();
	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader toggle={toggle}>
				{title || `${intl.formatMessage({id: 'dashboards.examDetail.stepCancellation'})}`}
			</ModalHeader>
			<ModalBody>
				<Row>
					<Col>
						<FormGroup className="justificativa-cancelar">
							<Label>{intl.formatMessage({id: 'dashboards.examDetail.justificationCancellation'})}</Label>
							<Input
								type="textarea"
								name="text"
								placeholder={intl.formatMessage({id: "dashboards.examDetail.justificationForReopening"})}
								maxLength="100"
								onChange={(e) => setJustificativa(e.target.value)}
								value={justificativaCancelar}
							/>
						</FormGroup>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button onClick={toggle} color="secondary">
					{`${intl.formatMessage({id: 'dashboards.examDetails.cancel'})}`}
				</Button>
				<Button
					onClick={cancelarEtapa}
					disabled={!justificativaCancelar}
					color="primary"
				>
					{confirmTextLabel || `${intl.formatMessage({id: 'dashboards.examDetail.cancelStep'})}`}
				</Button>
			</ModalFooter>
		</Modal>
	);
}

export default CancelamentoComponent;



// WEBPACK FOOTER //
// ./src/componentes/cancelamento/cancelamento.component.jsx